import {ImageSize, ImageSizeGroup} from "@globals/functions/imageUtils";

export default function getDefaultDishDetailsImageSizeGroup(): ImageSizeGroup {
  const ASPECT_RATIO = 1.16;
  const COMMON_DISH_IMAGE_WIDTHS = [
    130, 198, 270, 317, 408, 446, 606, 705, 940,
  ];
  const MAX_IMAGE_WIDTH_FOR_MOBILE = 1220;
  const imageSizes = COMMON_DISH_IMAGE_WIDTHS.map(
    (width) => new ImageSize(width, Math.round(width / ASPECT_RATIO))
  );

  imageSizes.push(
    new ImageSize(
      MAX_IMAGE_WIDTH_FOR_MOBILE,
      Math.round(MAX_IMAGE_WIDTH_FOR_MOBILE / ASPECT_RATIO),
      40 // We should use a lower quality, since this size will only ever be used on mobile
    )
  );

  return new ImageSizeGroup(imageSizes);
}
